import { UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';
import { CalendarioUtenteGiorno } from '../../interfaces/CalendarioUtenteGiorno';

// Stesso endpoint del giornaliero Utente (UsersHoursCalendar.ts), con una chiamata a
// parte perché quella inghiotte gli errori: qui un errore deve diventare "Non
// disponibile", non "Nessuno in servizio".
export const getInServizio = async (
  pointOfSaleId: string,
  giorno: string,
  signal?: AbortSignal
): Promise<CalendarioUtenteGiorno[]> => {
  try {
    const {
      data: { data },
    } = await axios.post(
      `/api/CalendarUser/GetAll`,
      { pointOfSaleId, date: giorno },
      { params: { dc: Date.now() }, signal }
    );
    return data ?? [];
  } catch (error) {
    if (!axios.isCancel(error)) console.trace(error);
    throw error;
  }
};

type ChiaveInServizio = readonly ['in-servizio', string, string];

/**
 * Query "in servizio" di un giorno, una per ogni giorno visibile della fascia
 * Presenze (useQueries): la cache per giorno evita nuove chiamate passando da
 * Settimana a Giorno, e l'errore di un giorno resta in quella cella.
 */
export const inServizioQueryOptions = (
  pointOfSaleId: string,
  giorno: string,
  enabled: boolean
): UseQueryOptions<
  CalendarioUtenteGiorno[],
  unknown,
  CalendarioUtenteGiorno[],
  ChiaveInServizio
> => ({
  queryKey: ['in-servizio', pointOfSaleId, giorno],
  queryFn: ({ signal }) => getInServizio(pointOfSaleId, giorno, signal),
  enabled: enabled && !!pointOfSaleId,
  // Le app che montano il pacchetto hanno useErrorBoundary: true di default e
  // nessun ErrorBoundary: senza questa opzione un errore smonterebbe la pagina.
  useErrorBoundary: false,
  // Un orario cambiato nei turni deve comparire tornando in agenda, ma dentro i 60
  // secondi (per esempio tornando su una settimana appena vista) non si richiede.
  staleTime: 60000,
  // La console di FOCUS 10 ha cacheTime 0 di default e FOCUS WEB un giorno: senza
  // questo valore, nella console i dati sparirebbero appena la fascia o il giorno
  // escono di vista, e i 60 secondi qui sopra varrebbero solo in FOCUS WEB.
  cacheTime: 300000,
  refetchOnMount: true,
  refetchOnWindowFocus: false,
  refetchInterval: 300000,
});
